<template>
    <div class='list-box'>
        <div class="check-box">
            <van-checkbox v-model="page.checked" shape="square" @change="getPageList">待评价</van-checkbox>
        </div>
        <template v-if="list.length">
            <div class="item-box" v-for="(item, index) in  list " :key="index">
                <div class="top-info">
                    <div>{{ item.memberName }}</div>
                    <div class="age-box">
                        {{ `${{ 1: '男', 0: '女' }[item.memberSex] || '未知'} | ${item.memberAge + '岁'}` }}
                    </div>
                    <div class="status" :style="{ color: { 0: '#ff6833', 1: '#8f8f8f' }[item.status] }">
                        {{ getDictOptionsLabel(statusList, item.status) }}
                    </div>
                </div>
                <div class="item-info">
                    <div class="item-lable">来源：</div>
                    <div class="item-value">
                        {{ item.originName }}
                        {{ `（${askMethodTypes.findValue({ value: item.askType })}${item.askNo}）` }}
                    </div>
                </div>
                <div style="display: flex;align-items: center;justify-content: space-between;">
                    <div class="item-info">
                        <div class="item-lable">健康管家：</div>
                        <div class="item-value">{{ item.assistantName || '-' }}</div>
                    </div>
                    <div class="item-info">
                        <div class="item-lable">接诊医生：</div>
                        <div class="item-value">{{ item.doctorName || '-' }}</div>
                    </div>
                </div>
                <div class="item-info">
                    <div class="item-lable">支付时间：</div>
                    <div class="item-value">{{ item.payTime || '-' }}</div>
                </div>
                <div class="button-box">
                    <van-button type="info" plain square size="small" @click="onViewAskInfo(item)"
                        class="write-box">查看问诊</van-button>
                    <van-button type="info" square size="small" @click="onEvaluate(item)" class="write-box"
                        v-if="item.status === 0">
                        满意度评价
                    </van-button>
                    <van-button type="info" plain square size="small" @click="onEvaluate(item)" class="write-box"
                        v-else>
                        查看评价
                    </van-button>
                </div>
            </div>
            <div class="pagination" v-if="page.total > page.pageSize" style="padding: 20px 0;">
                <van-pagination v-model="page.pageNo" :total-items="page.total" :items-per-page="page.pageSize"
                    @change="pageChange">
                    <template #prev-text>
                        <van-icon name="arrow-left" />
                    </template>
                    <template #next-text>
                        <van-icon name="arrow" />
                    </template>
                    <template #page="{ text }">{{ text }}</template>
                </van-pagination>
            </div>
        </template>
        <van-empty description="暂无数据" v-else />
    </div>
</template>

<script>
import { mapGetters } from 'vuex';
import { getEvaluateList } from '@/api/evaluate'
import { getDictOptionsLabel } from '@/utils/function'
import { askMethodTypes } from '@/hooks/useAsk'

export default {
    name: 'subscribe-list',
    components: {
    },
    data() {
        return {
            askMethodTypes,
            list: [],
            page: {
                pageNo: 1,
                pageSize: 10,
                askNoOrMemberName: '',
                total: 0,
                checked: false
            },
            statusList: [
                {
                    label: '待评价',
                    value: 0
                },
                {
                    label: '已完成',
                    value: 1
                },
            ],
        }
    },
    methods: {
        getDictOptionsLabel,
        setPageParams(keyword) {
            this.page.pageNo = 1
            this.page.pageSize = 10
            this.page.askNoOrMemberName = keyword
            this.getPageList()
        },
        async getPageList() {
            try {
                const params = {
                    ...this.page,
                    assistantNo: this.$store.state.assistantNo,
                    doctorNo: this.$store.state.assistantNo,
                    status: this.page.checked ? 0 : null,
                    isAsk: true,
                }
                if (this.getLoginRole === '医助') {
                    delete params.doctorNo
                } else {
                    delete params.assistantNo
                }
                const { data: { list, total } } = await getEvaluateList(params)
                this.list = list
                this.page.total = total
            } catch (error) {
                this.list = []
                console.log(error)
            }
        },
        pageChange(pageNo) {
            this.page.pageNo = pageNo
            this.getPageList()
        },
        onEvaluate(item) {
            this.$router.push({
                name: 'Evaluate',
                query: {
                    id: item.id,
                    askNo: item.askNo
                }
            })
        },
        onViewAskInfo(item) {
            this.$router.push({
                name: 'InquiryInfo',
                query: {
                    askNo: item.askNo
                }
            })
        }
    },
    computed: {
        ...mapGetters(['getLoginRole']),
    },
    watch: {},
    created() {
        this.getPageList()
    },
    activated() {
        this.getPageList()
    }
}
</script>
<style lang='scss' scoped>
.list-box {
    .check-box {
        padding: 15px;
        background: #fff;
    }

    .item-box {
        background: #fff;
        border-radius: 0 0 4px 4px;
        padding: 15px;

        &+.item-box {
            margin-top: 15px;
        }



        .top-info {
            font-size: 16px;
            font-weight: bold;
            color: #333333;
            display: flex;
            align-items: center;

            .type-box {
                font-size: 12px;
                width: 80px;
                height: 22px;
                font-weight: normal;
                color: #FFFFFF;
                display: flex;
                align-items: center;
                justify-content: center;

                &.video {
                    background: url('@/assets/images/subscribe/video.png') no-repeat center/cover;
                }

                &.picture {
                    background: url('@/assets/images/subscribe/picture.png') no-repeat center/cover;
                }
            }

            .age-box {
                padding: 0 10px;
            }

            .status {
                margin-left: auto;
                color: #FFA200;
            }
        }

        .item-info {
            flex: 1;
            display: flex;
            align-items: center;
            margin-top: 12px;
            font-size: 14px;

            .item-lable {
                color: #666666;
            }

            .item-value {
                color: #333333;
            }
        }

        .button-box {
            display: flex;
            margin-top: 10px;
            justify-content: flex-end;

            .write-box {
                margin-left: 12px;
                border-radius: 8px;
                height: 30px;

                &.van-button--plain {
                    background: #f5f5f5;
                }
            }
        }
    }
}
</style>